import { AbortError } from '@app/errors/AbortError'

import { loadScript } from './loadScript'

export class TelegramSDK {
  private static initPromise: Promise<void> | null = null

  botId: string
  name: string

  constructor(botId: string, name: string) {
    this.botId = botId
    this.name = name
  }

  static async init() {
    if (window.Telegram) return
    if (!TelegramSDK.initPromise) {
      TelegramSDK.initPromise = loadScript('https://telegram.org/js/telegram-widget.js?16').then(() => {
        if (!window.Telegram) {
          throw new Error('Failed to load Telegram SDK')
        }
      })
    }
    await TelegramSDK.initPromise
  }

  login() {
    if (!window.Telegram) return Promise.reject(new Error('Telegram not loaded'))
    return new Promise<{ bot: string; auth_data: Telegram.AuthData }>((resolve, reject) => {
      window.Telegram.Login.auth(
        {
          bot_id: this.botId,
          request_access: 'write',
        },
        data => {
          if (!data) {
            reject(new AbortError('Telegram login was aborted'))
          } else {
            resolve({ bot: this.name, auth_data: data })
          }
        }
      )
    })
  }
}
